import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { WORKS } from "./data";

export const Work = () => {
  return (
    <section id="work" className="bg-[#093125] py-24 md:py-36" data-testid="work-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <span className="eyebrow text-[#A6874E]">Selected Work</span>
        </Reveal>
        <div className="mt-8 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16 md:mb-20">
          <Reveal delay={0.1}>
            <h2
              className="font-grotesk font-bold uppercase text-[#F2EDE1] leading-[0.98] tracking-tight text-4xl sm:text-5xl md:text-6xl"
              data-testid="work-heading"
            >
              Ideas made<br />tangible.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-xs md:text-sm leading-relaxed text-[#F2EDE1]/55 max-w-xs">
              A selection of recent client websites and landing-page projects — real work,
              designed and built by the Elevora team.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-x-10 gap-y-14">
          {WORKS.map((w, i) => (
            <Reveal key={w.title} delay={(i % 2) * 0.12}>
              <a
                href={w.url || undefined}
                target={w.url ? "_blank" : undefined}
                rel={w.url ? "noopener noreferrer" : undefined}
                className={`group block ${w.url ? "" : "cursor-default"}`}
                data-testid={`work-card-${i}`}
              >
                <div className="relative overflow-hidden aspect-[16/10] bg-[#0B3D2E]">
                  <img
                    src={w.image}
                    alt={w.title}
                    loading="lazy"
                    className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-[#0B3D2E]/15 group-hover:bg-transparent transition-colors duration-700" />
                </div>
                <div className="flex items-center justify-between mt-5">
                  <h3 className="text-[#F2EDE1] text-base md:text-lg font-semibold group-hover:text-[#A6874E] transition-colors duration-300">
                    {w.title}
                  </h3>
                  {w.url && (
                    <span className="eyebrow text-[#F2EDE1]/60 group-hover:text-[#A6874E] transition-colors duration-300 flex items-center gap-2">
                      View Project
                      <ArrowUpRight className="w-3 h-3" />
                    </span>
                  )}
                </div>
                <p className="text-xs text-[#F2EDE1]/50 mt-2">{w.desc}</p>
                <p className="text-[10px] tracking-[0.25em] uppercase text-[#A6874E]/80 mt-2">{w.tag}</p>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
